import React, { useState, useEffect } from "react";
import axiosInstance from "../../services/auth";
import "./Logistics.css"; // reuse your existing CSS or update as needed
import { toast } from "react-toastify";

const StockForm = ({ selectedCompany, companyId, stock, onClose }) => {
  // Get current user data (for createdBy)
  const authData =
    JSON.parse(localStorage.getItem("authData")) ||
    JSON.parse(sessionStorage.getItem("authData"));
  const currentUserId = authData?._id;

  // Initialize form state.
  // If editing, pre-populate fields using the stock object.
  const initialFormData = stock
    ? {
        name: stock.name || "",
        description: stock.description || "",
        remark: stock.remark || "",
        category: stock.category || "",
        unit: stock.unit || "",
        grossWeight: stock.grossWeight || "",
        stockAQuantity: stock.stockAQuantity ?? "",
        stockBQuantity: stock.stockBQuantity ?? "",
      }
    : {
        name: "",
        description: "",
        remark: "",
        category: "",
        unit: "",
        grossWeight: "",
        stockAQuantity: "",
        stockBQuantity: "",
      };

  const [formData, setFormData] = useState(initialFormData);
  const [loading, setLoading] = useState(false);

  // Generic change handler.
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Close modal when clicking outside the dialog.
  const handleOutsideClick = (e) => {
    if (e.target.classList.contains("modal")) {
      onClose();
    }
  };

  // Prevent background scrolling while modal is open.
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "");
  }, []);

  // Form submission handler.
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation.
    if (
      !formData.name ||
      !formData.description ||
      !formData.category ||
      !formData.unit
    ) {
      toast.error("Please fill required fields.");
      return;
    }

    setLoading(true);
    const payload = {
      ...formData,
      companyId,
      createdBy: currentUserId,
    };

    try {
      if (stock) {
        // If editing, update the existing stock.
        await axiosInstance.patch(`/logistics/stock/${stock._id}`, payload);
        toast.success("Stock updated successfully");
      } else {
        // Otherwise, create a new stock.
        await axiosInstance.post("/logistics/stock", payload);
        toast.success("Stock created successfully");
      }
      onClose();
    } catch (error) {
      // console.error("Error saving stock:", error);
      toast.error("Error saving stock");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="modal show d-block"
      tabIndex="-1"
      onClick={handleOutsideClick}
      style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <div
        className="modal-dialog modal-lg modal-dialog-centered"
        role="document"
      >
        <div className="modal-content loan_model">
          <div className="modal-header text-white text-center vesel_form">
            <h5 className="modal-title">
              {stock ? "Edit Stock" : "Create Stock"}
            </h5>
            <button
              type="button"
              className="btn-close text-white"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body vesel_form">
            <form onSubmit={handleSubmit}>
              {/* Stock Details Section */}
              <div className="card shadow-sm mb-4 rounded-3">
                <div className="card-body">
                  <h5 className="card-title text-center mb-4">Stock Details</h5>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Category</label>
                      <input
                        type="text"
                        className="form-control"
                        name="category"
                        value={formData.category}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Unit</label>
                      <input
                        type="text"
                        className="form-control"
                        name="unit"
                        value={formData.unit}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Specification</label>
                      <input
                        type="text"
                        className="form-control"
                        name="grossWeight"
                        value={formData.grossWeight}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Opening Qty (Godown A)</label>
                      <input
                        type="number"
                        className="form-control"
                        name="stockAQuantity"
                        value={formData.stockAQuantity}
                        onChange={handleChange}
                        min="0"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Opening Qty (Godown B)</label>
                      <input
                        type="number"
                        className="form-control"
                        name="stockBQuantity"
                        value={formData.stockBQuantity}
                        onChange={handleChange}
                        min="0"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Description</label>
                      <textarea
                        className="form-control"
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        rows="2"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Remark</label>
                      <textarea
                        className="form-control"
                        name="remark"
                        value={formData.remark}
                        onChange={handleChange}
                        rows="2"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-4 text-center">
                <button type="submit" className="button-2" disabled={loading}>
                  {loading
                    ? stock
                      ? "Updating"
                      : "Creating"
                    : stock
                      ? "Update Stock"
                      : "Create Stock"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockForm;
